export const getDeleteVoteEventData = (UID: string, userToken: string, isOwner: boolean) => {
    return [
        {
            type: "build",
            action: "delete",
            entities: [
                {
                    entityType: "vote",
                    UID: UID,
                    token: userToken,
                    isOwner,
                },
            ],
        },
    ];
};

export const getRenameVoteEventData = (UID: string, name: string) => {
    return [
        {
            type: "property",
            UID: UID,
            fixType: "text",
            entityType: "vote",
            state: {
                text: name,
            },
        },
    ];
};
